export default __webpack_public_path__ + "static/media/audio-upload.3f31da15.svg";